import CustomTimeline from './CustomTimeline';
import CustomTimelineOld from './CustomTimelineold';
import './Calendar.css';

const Calendar = (props) => {
  return <CustomTimeline {...props} />;
};

export default Calendar;
